import {useDate} from "./useDate";
import {useLanguageForShared} from "../utils/languages/useLanguageForShared";

export function useDateCustom(){
    const {lang} = useLanguageForShared();
    const data = useDate(lang);
    return {data}
}
